import { jsx as _jsx } from "react/jsx-runtime";
import { CatButton } from '@blocks-react/components/Button';
import cx from 'classnames';
export const HeaderStoreLocationButton = ({ label, onClick, isStoreLocationOptimizationFlag = false, isMobile = false }) => {
    return (_jsx(CatButton, { className: cx('d-flex', {
            'justify-content-end': isStoreLocationOptimizationFlag && isMobile
        }), onClick: onClick, variant: "primary", fullWidth: !(isStoreLocationOptimizationFlag && isMobile), children: label }));
};
